import React from 'react';
import {FormattedMessage} from 'react-intl';
import {optimizerPlusTitle} from 'helpers/dataHelpers';
import {chemicalBaseTypes} from 'helpers/constants';
import {newNotesEnabled} from 'features';

//Group event types into common groups for sorting.
export const customerTypes = [5, 12, 13, 14, 29, 30, 32, 41, 42, 43, 57, 58, 59, 60, 67, 68, 70];
export const contactTypes = [18, 19, 20, 45];
export const analysisTypes = [6, 7, 8, 31, 61, 62];
export const analysisScriptTypes = [53, 54, 55];
export const filterAnalysisTypes = [6, 7, 8, 31, 61, 62, 53, 54, 55, 63, 64, 65];
export const systemNoteTypes = [15, 16, 17, 49];
export const customerNoteTypes = [9, 10, 11, 44];
export const followUpTypes = [1, 2, 3, 4, 50, 51, 52];
export const systemTypes = [21, 22, 23, 24, 33, 46, 47, 48, 66];
export const emailTypes = [25, 26, 27, 28, 34, 35, 36, 37, 38, 39, 40, 56];
export const sourceWaterType = [63, 64, 65];
export const POSTypes = [69];

export const analysisNoteTypes = [70, 71];
export const allNoteTypes = customerNoteTypes.concat(systemNoteTypes).concat(analysisNoteTypes);

//Color groups
export const greenGroup = [6, 9, 12, 15, 18, 21, 65, 69, 70];
export const greenGroupColor = '#78be20';

export const redGroup = [10, 14, 16, 19, 22];
export const redGroupColor = '#d94e2b';

export const greyGroup = [59];
export const greyGroupColor = '#b0b7bd';

//Those not mentioned are blue
export const blueGroupColor = '#0094d6';

//Types of events used for system filter ( allows system  and analysis events)
export const systemFilterTypes = [6, 7, 8, 21, 22, 23, 24];

//Events with View Details Link (system link only)
export const systemDetailsLinkTypes = [21, 23, 24, 34, 6, 7, 32, 54, 55, 56, 9, 11, 15, 17, 49, 44, 46, 47, 48, 53, 54, 55, 61, 62, 63, 64, 65];

export const noteTypeFilters = (formatMessage) => [
  {
    label: formatMessage({id: 'notes.type.account'}),
    types: customerNoteTypes,
  },
  {
    label: formatMessage({id: 'notes.type.system'}),
    types: systemNoteTypes,
  },
  {
    label: formatMessage({id: 'notes.type.analysis'}),
    types: analysisNoteTypes,
  },
];


export const notesEventsLabels = [
  {
    label: <FormattedMessage id='timeline.notes.type.account'/>,
    types: customerNoteTypes,
  },
  {
    label: <FormattedMessage id='timeline.notes.type.system'/>,
    types: systemNoteTypes,
  },
  {
    label: <FormattedMessage id='timeline.notes.type.analysis'/>,
    types: analysisNoteTypes,
  },
];


export let typeEventFilters = (formatMessage) => {
  let filters = [
    {
      label: formatMessage({id: 'general.account'}),
      types: customerTypes,
    },
    {
      label: formatMessage({id: 'general.contacts'}),
      types: contactTypes,
    },
    {
      label: formatMessage({id: 'general.analysis'}),
      types: filterAnalysisTypes,
    },
    {
      label: formatMessage({id: 'general.system'}),
      types: systemTypes,
    },
    {
      label: formatMessage({id: 'general.notes.account'}),
      types: customerNoteTypes,
    },
    {
      label: formatMessage({id: 'general.notes.system'}),
      types: systemNoteTypes,
    },
    {
      label: formatMessage({id: 'general.followups'}),
      types: followUpTypes,
    },
    {
      label: formatMessage({id: 'general.emails'}),
      types: emailTypes,
    },
    {
      label: formatMessage({id: 'general.pos'}),
      types: POSTypes,
    },
  ];

  if (newNotesEnabled) {
    filters = filters.filter(x => x.types !== customerNoteTypes && x.types !== systemNoteTypes);
    filters.push({
      label: formatMessage({id: 'general.notes'}),
      types: allNoteTypes,
    });
  }

  return filters;
};


export function getActionType(type) {
  let name = '';

  switch (type) {
    case 1:
      name = <FormattedMessage id='timeline.event.type.added' />;
      break;
    case 2:
      name = <FormattedMessage id='timeline.event.type.updated' />;
      break;
    case 3:
      name = <FormattedMessage id='timeline.event.type.deleted' />;
      break;
    case 4:
      name = <FormattedMessage id='timeline.event.type.imported' />;
      break;
    case 5:
      name = <FormattedMessage id='timeline.event.type.sent' />;
      break;
    case 6:
      name = <FormattedMessage id='timeline.event.type.deactivated' />;
      break;
    case 7:
      name = <FormattedMessage id='timeline.event.type.activated' />;
      break;
    case 8:
      name = <FormattedMessage id='timeline.event.type.script' />;
      break;
    case 9:
      name = <FormattedMessage id='timeline.event.type.phone' />;
      break;
    case 10:
      name = <FormattedMessage id='timeline.event.type.dismissed' />;
      break;
    case 11:
      name = <FormattedMessage id='timeline.event.type.opened' />;
      break;
    case 12:
      name = <FormattedMessage id='timeline.event.type.closed' />;
      break;
    case 13:
      name = <FormattedMessage id='timeline.event.type.merged' />;
      break;
    case 14:
      name = <FormattedMessage id='timeline.event.type.verified' />;
      break;
    case 15:
      name = <FormattedMessage id='timeline.event.type.purchase' />;
      break;
    default:
  }
  return name;
}

// Array keys for timeline events filtering
export const keysNotAllowedUpdated = ['Modified', 'Imported'];

export function poolPropertiesInfo(formatMessage, branch, systemType, chemicalBaseTypeID) {
  return{
    Volume: {
      label: formatMessage({id: 'general.volume'}),
    },
    Finish: {
      label: formatMessage({id: 'general.finish'}),
      valuesNeedTranslation: true,
    },
    Property: {
      label: formatMessage({id: 'general.property'}),
      valuesNeedTranslation: true,
    },
    Location: {
      label: formatMessage({id: 'general.location'}),
      valuesNeedTranslation: true,
    },
    GroundLevel: {
      label: formatMessage({id: 'general.ground.level'}),
      valuesNeedTranslation: true,
    },
    Ionization: {
      label: formatMessage({id: 'system.details.ionization.catalyst'}),
    },
    Ozonator: {
      label: formatMessage({id: 'general.ozonator'}),
    },
    JettedReturns: {
      label: formatMessage({id: 'system.details.jetted.returns'}),
    },
    Sanitizer: {
      label: formatMessage({id: 'general.sanitizer'}),
      isProd: true,
    },
    Oxidizer: {
      label: formatMessage({id: 'customer.product.profile.troubleshooting'}),
      isProd: true,
    },
    MaintOxidizer: {
      label: formatMessage({id: 'general.maint.oxidizer'}),
      isProd: true,
    },
    PrevAlgaecide: {
      label: formatMessage({id: 'general.prev.algicide'}),
      isProd: true,
    },
    pHAdjuster: {
      label: formatMessage({id: 'customer.product.profile.phadjuster'}),
      isProd: true,
    },
    pHBuffer: {
      label: formatMessage({id: 'general.ph.buffer'}),
      isProd: true,
    },
    WinterOxidizer: {
      label: formatMessage({id: 'customer.product.profile.winterizer'}),
      isProd: true,
    },
    WinterAlgicide: {
      label: formatMessage({id: 'chemicals.winter.algicide'}),
      isProd: true,
    },
    WaterlineControl: {
      label: formatMessage({id: 'general.waterline.control'}),
      isProd: true,
    },
    Enzymes: {
      label: formatMessage({id: 'chemicals.natural.spa.enzyme'}),
    },
    InfloorCleaner: {
      label: formatMessage({id: 'system.details.infloor.cleaning'}),
    },
    OxysheenTreatment: {
      label: formatMessage({id: 'chemicals.oxysheen'}),
    },
    UsingNaturalResult: {
      label: formatMessage({id: 'general.natural.result'}),
    },
    FilterMedia: {
      label: formatMessage({id: 'general.filter.media'}),
      valuesNeedTranslation: true,
    },
    UsingVanishingAct: {
      label: formatMessage({id: 'chemicals.using.vanishing.act'}),
    },
    MaintClarifier: {
      label: formatMessage({id: 'general.maint.clarifier'}),
      isProd: true,
    },
    CannotVacToWaste: {
      label: formatMessage({id: 'system.details.vacuum.waste'}),
    },
    SoftSoakTRIO: {
      label: formatMessage({id: 'chemicals.softsoak.trio'}),
    },
    InstalledByDealer: {
      label: formatMessage({id: 'system.details.installed.by'}, {name: ''}),
    },
    WarrantyDate: {
      label: formatMessage({id: 'system.details.warranty.date'}),
      isDate: true,
    },
    Waterfall: {
      label: formatMessage({id: 'general.waterfall'}),
    },
    AttachedSpa: {
      label: formatMessage({id: 'system.details.attached.spa'}),
    },
    WaterFountain: {
      label: formatMessage({id: 'system.details.water.fountain'}),
    },
    UsingSmartShield: {
      label: formatMessage({id: 'general.smart.shield'}),
    },
    ScanCount: {
      label: formatMessage({id: 'system.widget.lifetime.analyses'}),
    },
    NextAnalysisDate: {
      label: formatMessage({id: 'general.next.analysis'}),
      isDate: true,
    },
    FilterCleanedDate: {
      label: formatMessage({id: 'general.filter.cleaned'}),
      isDate: true,
    },
    MSCellCleanedDate: {
      label: formatMessage({id: 'analysis.cell.cleaned.date'}),
      isDate: true,
    },
    PrevAnalysisDate: {
      label: formatMessage({id: 'general.last.analysis.date'}),
      isDate: true,
    },
    Stabilizer: {
      label: formatMessage({id: 'general.stabilizer'}),
      isProd: true,
    },
    PoolOpeningComplete: {
      label: formatMessage({id: 'chemicals.pool.opening.complete'}),
    },
    LastCleanedDrained: {
      label: formatMessage({id: 'analysis.insert.cleaned.drained'}),
      isDate: true,
    },
    NickName: {
      label: formatMessage({id: 'system.details.system.nickname'}),
    },
    SpaComplete: {
      label: formatMessage({id: 'chemicals.spa.complete'}),
    },
    TruBlueStatus: {
      label: formatMessage({id: 'general.trublue.status'}),
      valuesNeedTranslation: true,
    },
    IdealSaltPPM: {
      label: chemicalBaseTypeID === chemicalBaseTypes.mineralSpringsPool ?
      formatMessage({id: 'chemicals.ideal.mineral.ppm'}) :
      formatMessage({id: 'chemicals.ideal.salt.ppm'}),
    },
    ChemicalBaseTypeID: {
      label: formatMessage({id: 'system.details.system.name'}),
      valuesNeedTranslation: true,
    },
    UsingOptimizerPlus: {
      label: optimizerPlusTitle(branch, {typeID: systemType}, formatMessage),
    },
    TypeID: {
      label: formatMessage({id: 'general.system.type'}),
      valuesNeedTranslation: true,
    },
    SeasonStart: {
      label: formatMessage({id: 'general.season.start'}),
      isDate: true,
    },
    SeasonEnd: {
      label: formatMessage({id: 'general.season.end'}),
      isDate: true,
    },
  };
}


export function customersContactsPropertiesInfo(formatMessage) {
  return{
    AccountNo: {
      label: formatMessage({id: 'general.alexid'}),
    },
    NameFirst: {
      label: formatMessage({id: 'general.first.name'}),
    },
    NameLast: {
      label: formatMessage({id: 'general.last.name'}),
    },
    Address1: {
      label: formatMessage({id: 'general.address.1'}),
    },
    Address2: {
      label: formatMessage({id: 'general.address.2'}),
    },
    State: {
      label: formatMessage({id: 'general.state'}),
    },
    Zip: {
      label: formatMessage({id: 'general.postal-code'}),
    },
    City: {
      label: formatMessage({id: 'general.city'}),
    },
    HomePhone: {
      label: `${formatMessage({id: 'general.phone.number'})} (${formatMessage({id: 'general.primary'})})`,
    },
    WorkPhone: {
      label: `${formatMessage({id: 'general.phone.number'})} (${formatMessage({id: 'general.alternate'})})`,
    },
    MobilePhone: {
      label: `${formatMessage({id: 'general.phone.number'})} (${formatMessage({id: 'general.alternate'})})`,
    },
    Organization: {
      label: formatMessage({id: 'customer.organization'}),
    },
    ContactEmailPreferences: {
      label: formatMessage({id: 'general.emails.preferences'}),
    },
  };
}

export function followUpTypeIDs(formatMessage) {
  return{
    1: formatMessage({id: 'general.water.clarity'}),
    2: formatMessage({id: 'general.algae'}),
    3: formatMessage({id: 'general.surface.problems'}),
    4: formatMessage({id: 'general.chlorine.demand'}),
  };
};

